<script>
import anychart from 'anychart'

export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },

    chartData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      chart: null,
    }
  },

  watch: {
    chartAreaData() {
      // set our data to data set
    },
    chartColumnData() {
      // set our data to data set
    },
  },

  mounted() {
    anychart.licenseKey('openindustry.org-312f7279-c0b595db')
    this.chart = anychart.sparkline()
    let credits = this.chart.credits()
    credits.enabled(false)

    this.chart.container(anychart.graphics.create(this.$el))

    this.chart.data(this.chartData)

    this.chart.seriesType('column')

    this.chart
      .yScale()
      .minimum('0')
      .maximum('75')
    this.chart.padding(0)
    this.chart.lineMarker().value(60)

    this.chart.background().fill('#262626')
    this.chart.lineMarker().stroke('#2eb85c', 2, '3 3')

    this.chart.fill('#666666')
    this.chart.stroke('#cccccc')
    // this.chart.maxFill('green')
    // this.chart.minFill('red')
    this.chart.height(40)

    // initiate chart drawing
    this.chart.draw()
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },

  methods: {
    method() {},
  },
}
</script>

<template>
  <div class="spark-chart"></div>
</template>
<style>
.spark-chart {
  max-height: 60px;
  border: 1px solid #666666;
  border-radius: 2px;
  padding: 6px;
}
</style>
